var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleDownLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 256C16 388.58 123.42 496 256 496S496 388.58 496 256C496 123.418 388.58 16 256 16S16 123.418 16 256ZM159.369 173.335C165.347 170.849 172.23 172.23 176.804 176.804L222.059 222.059L289.941 154.177C302.438 141.68 322.699 141.68 335.196 154.177L357.823 176.804C370.32 189.301 370.32 209.562 357.823 222.059L289.941 289.941L335.196 335.196C339.77 339.77 341.151 346.653 338.665 352.631C336.19 358.619 330.357 362.508 323.882 362.508H165.49C156.655 362.508 149.492 355.345 149.492 346.51V188.118C149.492 181.643 153.381 175.81 159.369 173.335Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDownLeft);
export default __webpack_public_path__ + "static/media/circle-down-left.572f1e6c7683c5177cefa626f78363e0.svg";
export { ForwardRef as ReactComponent };